import { InjectionToken } from '@angular/core';
/** @hidden */ export const UIROUTER_ROOT_MODULE = new InjectionToken('UIRouter Root Module');
/** @hidden */ export const UIROUTER_MODULE_TOKEN = new InjectionToken('UIRouter Module');
/** @hidden */ export const UIROUTER_STATES = new InjectionToken('UIRouter States');
